<template>
	<xm-page class="relevance">
        <div class="tip">请选择需要自主报名的学员</div>
        <div>
            <ul class="relevance-item">
              <li
                v-for="(item, index) in bindStudentList" :key="index"  @click="jumpToMall(item)"
              >
                <div class="avatar">
                  <img
                    :src="item.studentAvatar || avatarImg"
                    alt=""
                  >
                </div>
                <div class="name_inst">
                <div class="name">
                  <span class="name-content">{{item.studentName}}</span>
                </div>
                <div class="inst">在读机构：{{item.instName}}</div>
                <span 
                  class="control icon iconfont"
                >&#xe68a;</span>
              </div>
              </li>
            </ul>
        </div>
	</xm-page>
</template>
<script>
    import User from "@/core/user";
    import UserService from '@/service/UserService';
    export default {
   	 	data() {
            return{
              bindStudentList:[],
              avatarImg: require("../../images/avatar.png"),
            }
        },
        created(){
          
        },
        mounted(){
          this.getBindStudentList();
        },
        methods: {
          getBindStudentList() {
            const appId = User.appId();
            let that = this;
            UserService.getMergeBindStudentList(appId).then(res => {
              let  mergelistArr = [];
              for(var i=0;i<res.result.length;i++){
                mergelistArr = mergelistArr.concat(res.result[i].groupStudentVOList)
              }
              for(var i=0; i <mergelistArr.length;i++){
                if(mergelistArr[i].instId === this.$route.query.instId){
                  this.bindStudentList.push(mergelistArr[i]);
                }
              }
            });
          },
          jumpToMall(item) {
            User.setUserInfo(item);
            window.router.push({
              name: 'course_mall',
              query: {
                studentId: item.studentId,
                mallInstId: item.instId,
              },
            });
          },
        },
        components:{
           
        },
    }
</script>
<style lang="less">
	@import url(../../core/mixins.less);
  .relevance {
    .tip {
      color: #999;
      text-align: left;
      padding-left: 0.32rem;
      height: 0.72rem;
      line-height: 0.72rem;
      font-size: 0.26rem;
      background: #F4F6FA;
    }
    .relevance-item {
      display: flex;
      flex-direction: column;
      li {
        background-color: #ffffff;
        display: flex;
        position: relative;
        padding: 0.2rem 0.3rem 0;
        width: 100%;
        .avatar {
          border-radius: 50%;
          margin-right: 0.3rem;
          width: 1rem;
          > img {
            display: block;
            height: 1rem;
            width: 1rem;
            border-radius: 50%;
          }
        }
        .name_inst {
          display: flex;
          flex-direction: column;
          flex: 1;
          padding-bottom: 0.2rem;
          border-bottom: 1px solid #eee;
          .name {
            color: #333;
            margin-bottom: 0.14rem;
            display: flex;
            .name-content {
              flex: 1;
              .text-overflow-ellipsis();
              width: 3rem;
            }
            .unbind-btn {
              width: 1rem;
              font-size: 0.24rem;
              color: #3296fa;
              text-align: right;
            }
          }

          .inst {
            font-size: 0.26rem;
            color: #999999;
          }
          .control {
            padding: 0.3rem;
            font-size: 14px;
            color: #dedede;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        &:last-child {
          .name_inst {
            border-bottom: 0px;
          }
        }
      }
    }
    .add-student {
      padding: 0.26rem 0;
      background: #fff;
      font-size: 0.26rem;
      color: #333;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: auto;
        right: auto;
        height: 1px;
        width: 200%;
        background-color: #eee;
        display: block;
        z-index: 1;
        transform-origin: 0% 0%;
        transform: scale(0.5);
      }
      .icon {
        color: #3296fa;
        vertical-align: middle;
        margin-right: 0.1rem;
      }
      .add-text {
        vertical-align: middle;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/mall/SelectStudent.vue